const colors = {
  reset: '\x1b[0m',
  bright: '\x1b[1m',
  green: '\x1b[32m',
  yellow: '\x1b[33m',
  red: '\x1b[31m',
  cyan: '\x1b[36m',
  magenta: '\x1b[35m',
};

export const logger = {
  success: (message: string) => {
    console.log(`${colors.green}✨ ${message}${colors.reset}`);
  },
  info: (message: string) => {
    console.log(`${colors.cyan}ℹ️ ${message}${colors.reset}`);
  },
  warning: (message: string) => {
    console.log(`${colors.yellow}⚠️ ${message}${colors.reset}`);
  },
  error: (message: string, error?: any) => {
    console.error(`${colors.red}❌ ${message}${colors.reset}`);
    if (error) {
      console.error(`${colors.red}${error}${colors.reset}`);
    }
  },
  api: (message: string) => {
    console.log(`${colors.magenta}🌐 ${message}${colors.reset}`);
  },
  stats: (message: string) => {
    console.log(`${colors.bright}📊 ${message}${colors.reset}`);
  }
}; 